import { createSelector } from "@reduxjs/toolkit";

const selectIsLoading = (state) => state.utilityData.isLoading;
const selectIsMobile = (state) => state.utilityData.isMobile;
const selectToastId = (state) => state.utilityData.toastId;

export const manageUtilityDataSelector = createSelector(
  [selectIsLoading, selectIsMobile, selectToastId],
  (isLoading, isMobile, toastId) => ({
    isLoading,
    isMobile,
    toastId,
  })
);
